import React from 'react'
import { connect } from 'react-redux'
import {
  Box, Button, ButtonGroup, ClickAwayListener, Grow,
  MenuList, MenuItem, Paper, Popper
} from '@mui/material'
import { ArrowDropDown } from '@mui/icons-material'
import classNames from 'classnames'
import { sendWs, CLEAR } from '../../lib/send'
import { rxOpenClear } from '../../lib/rx_subject'
import { clearEditBoards } from '../../redux/actions/board'

const menuText = {
  allClear: 'オールクリア',
  partialClear: '一部クリア'
}

const Clear = ({ className, rule, clearEditBoards }) => {
  const [open, setOpen] = React.useState(false)
  const anchorRef = React.useRef(null)

  const [selected, setSelected] = React.useState('allClear')

  const onClick = () => {
    switch (selected) {
      case 'allClear':
        clearEditBoards()
        sendWs(CLEAR)
        break
      case 'partialClear':
        rxOpenClear.next(true)
        break
    }
  }

  const toggleOpen = () => {
    setOpen(prevOpen => !prevOpen)
  }

  const selectMenu = menuItem => {
    setSelected(menuItem)
    setOpen(false)
  }

  const closeMenu = evt => {
    if (!anchorRef.current || !anchorRef.current.contains(evt.target)) {
      setOpen(false)
    }
  }

  const menu = ({ TransitionProps }) => (
    <Grow {...TransitionProps}>
      <Paper>
        <ClickAwayListener onClickAway={closeMenu}>
          <MenuList className="clear-menu">
            <MenuItem className="all-clear-menu"
                      selected={selected === 'allClear'}
                      onClick={() => selectMenu('allClear')}>
              {menuText.allClear}
            </MenuItem>
            <MenuItem className="partial-clear-menu"
                      selected={selected === 'partialClear'}
                      onClick={() => selectMenu('partialClear')}>
              {menuText.partialClear}
            </MenuItem>
          </MenuList>
        </ClickAwayListener>
      </Paper>
    </Grow>
  )

  return (
    <Box className={classNames(className, 'clear')}>
      <ButtonGroup variant="outlined" color="mono"
                   ref={anchorRef}>
        <Button className="clear-button" onClick={onClick}>
          {menuText[selected]}
        </Button>
        <Button size="small" className="clear-menu-button"
                onClick={toggleOpen}>
          <ArrowDropDown />
        </Button>
      </ButtonGroup>
      <Popper open={open} anchorEl={anchorRef.current}
              placement="bottom-start" transition>
        {menu}
      </Popper>
    </Box>
  )
}

export default connect(
  state => ({
    rule: state.rule
  }),
  dispatch => ({
    clearEditBoards: () => dispatch(clearEditBoards())
  })
)(Clear)
